// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminConfigurations_checks__L\\+C4F {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
@media only screen and (max-width: 900px) {
  .AdminConfigurations_checks__L\\+C4F {
    flex-direction: column;
    gap: 2rem;
  }
}

.AdminConfigurations_formContainer__kG4VA {
  padding: 2rem 0;
}

.AdminConfigurations_accordionWrapper__LuX7A {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.AdminConfigurations_accordionItem__yDSsz {
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 0.625rem;
  overflow: hidden;
  transition: all 0.3s ease;
  background: var(--color-bg, #ffffff);
}
.AdminConfigurations_accordionItem__yDSsz:hover {
  border-color: var(--color-fash-primary-2, #333);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.AdminConfigurations_accordionHeader__pFrj9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, var(--color-bg, #fafafa) 0%, var(--color-bg, #ffffff) 100%);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}
.AdminConfigurations_accordionHeader__pFrj9:hover {
  background: linear-gradient(135deg, var(--color-bg, #f5f5f5) 0%, var(--color-bg, #fafafa) 100%);
}
.AdminConfigurations_accordionHeader__pFrj9.AdminConfigurations_isOpen__1hajw {
  background: linear-gradient(135deg, var(--color-fash-primary-2, #333) 0%, var(--color-fash-primary, #333) 100%);
}
.AdminConfigurations_accordionHeader__pFrj9.AdminConfigurations_isOpen__1hajw div {
  color: #ffffff;
}

.AdminConfigurations_accordionIcon__Ie2dZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 1rem;
  transition: transform 0.3s ease;
  font-size: 1.25rem;
  color: var(--color-fash-primary-2, #333);
}
.AdminConfigurations_accordionHeader__pFrj9.AdminConfigurations_isOpen__1hajw .AdminConfigurations_accordionIcon__Ie2dZ {
  transform: rotate(180deg);
  color: #ffffff;
}

.AdminConfigurations_accordionContent__hL5jP {
  padding: 1.5rem;
  background: rgba(0, 0, 0, 0.02);
  animation: AdminConfigurations_slideDown__zlHPq 0.3s ease-out;
}

@keyframes AdminConfigurations_slideDown__zlHPq {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.AdminConfigurations_submitButton__vd-\\+H {
  margin-top: 2.5rem;
}

.AdminConfigurations_gridTwoColumns__h4m29 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}
@media only screen and (max-width: 768px) {
  .AdminConfigurations_gridTwoColumns__h4m29 {
    grid-template-columns: 1fr;
  }
}

.AdminConfigurations_themes__O0rVR {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 600px) {
  .AdminConfigurations_themes__O0rVR {
    grid-template-columns: repeat(2, 1fr);
  }
}

.AdminConfigurations_theme__wT2lj {
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  padding: 2rem;
  background-color: var(--color-grey-7);
  cursor: pointer;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  height: fit-content;
}
.AdminConfigurations_theme__wT2lj > :first-child {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
}
.AdminConfigurations_theme__active__ech8G {
  border: 2px solid var(--color-fash-green-2);
}
.AdminConfigurations_theme__wT2lj:hover, .AdminConfigurations_theme__set__FnjtQ {
  border: 2px solid var(--color-fash-primary-2);
}
.AdminConfigurations_theme__wT2lj img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminConfigurations.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AACD;AAAC;EAJD;IAKE,sBAAA;IACA,SAAA;EAGA;AACF;;AAAA;EACC,eAAA;AAGD;;AAAA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAGD;;AAAA;EACC,8CAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;AAGD;AADC;EACC,+CAAA;EACA,yCAAA;AAGF;;AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,+FAAA;EAKA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAFD;AAIC;EACC,+FAAA;AAFF;AASC;EACC,+GAAA;AAPF;AAaE;EACC,cAAA;AAXH;;AAgBA;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,wCAAA;AAbD;AAeC;EACC,yBAAA;EACA,cAAA;AAbF;;AAiBA;EACC,eAAA;EACA,+BAAA;EACA,6DAAA;AAdD;;AAiBA;EACC;IACC,UAAA;IACA,4BAAA;EAdA;EAgBD;IACC,UAAA;IACA,wBAAA;EAdA;AACF;AAiBA;EACC,kBAAA;AAfD;;AAkBA;EACC,aAAA;EACA,8BAAA;EACA,SAAA;AAfD;AAiBC;EALD;IAME,0BAAA;EAdA;AACF;;AAiBA;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAdD;AAgBC;EALD;IAME,qCAAA;EAbA;AACF;;AAgBA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,eAAA;EACA,4CAAA;EACA,mBAAA;AAbD;AAeC;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAbF;AAgBC;EACC,2CAAA;AAdF;AAiBC;EAEC,6CAAA;AAhBF;AAmBC;EACC,WAAA;AAjBF","sourcesContent":[".checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 1rem 0 2rem 0;\n\t@media only screen and (max-width: 900px) {\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n}\n\n.formContainer {\n\tpadding: 2rem 0;\n}\n\n.accordionWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.25rem;\n}\n\n.accordionItem {\n\tborder: 1px solid var(--color-border, #e0e0e0);\n\tborder-radius: 0.625rem;\n\toverflow: hidden;\n\ttransition: all 0.3s ease;\n\tbackground: var(--color-bg, #ffffff);\n\n\t&:hover {\n\t\tborder-color: var(--color-fash-primary-2, #333);\n\t\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\t}\n}\n\n.accordionHeader {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding: 1.25rem 1.5rem;\n\tbackground: linear-gradient(\n\t\t135deg,\n\t\tvar(--color-bg, #fafafa) 0%,\n\t\tvar(--color-bg, #ffffff) 100%\n\t);\n\tborder: none;\n\tcursor: pointer;\n\ttransition: all 0.3s ease;\n\ttext-align: left;\n\n\t&:hover {\n\t\tbackground: linear-gradient(\n\t\t\t135deg,\n\t\t\tvar(--color-bg, #f5f5f5) 0%,\n\t\t\tvar(--color-bg, #fafafa) 100%\n\t\t);\n\t}\n\n\t&.isOpen {\n\t\tbackground: linear-gradient(\n\t\t\t135deg,\n\t\t\tvar(--color-fash-primary-2, #333) 0%,\n\t\t\tvar(--color-fash-primary, #333) 100%\n\t\t);\n\n\t\t:global(div) {\n\t\t\tcolor: #ffffff;\n\t\t}\n\t}\n}\n\n.accordionIcon {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tmargin-left: 1rem;\n\ttransition: transform 0.3s ease;\n\tfont-size: 1.25rem;\n\tcolor: var(--color-fash-primary-2, #333);\n\n\t.accordionHeader.isOpen & {\n\t\ttransform: rotate(180deg);\n\t\tcolor: #ffffff;\n\t}\n}\n\n.accordionContent {\n\tpadding: 1.5rem;\n\tbackground: rgba(0, 0, 0, 0.02);\n\tanimation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(-10px);\n\t}\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n.submitButton {\n\tmargin-top: 2.5rem;\n}\n\n.gridTwoColumns {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: 768px) {\n\t\tgrid-template-columns: 1fr;\n\t}\n}\n\n.themes {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgap: 2rem;\n\n\t@media only screen and (max-width: 600px) {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n.theme {\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder-radius: 1rem;\n\tpadding: 2rem;\n\tbackground-color: var(--color-grey-7);\n\tcursor: pointer;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\theight: fit-content;\n\n\t& > :first-child {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__active {\n\t\tborder: 2px solid var(--color-fash-green-2);\n\t}\n\n\t&:hover,\n\t&__set {\n\t\tborder: 2px solid var(--color-fash-primary-2);\n\t}\n\n\timg {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checks": `AdminConfigurations_checks__L+C4F`,
	"formContainer": `AdminConfigurations_formContainer__kG4VA`,
	"accordionWrapper": `AdminConfigurations_accordionWrapper__LuX7A`,
	"accordionItem": `AdminConfigurations_accordionItem__yDSsz`,
	"accordionHeader": `AdminConfigurations_accordionHeader__pFrj9`,
	"isOpen": `AdminConfigurations_isOpen__1hajw`,
	"accordionIcon": `AdminConfigurations_accordionIcon__Ie2dZ`,
	"accordionContent": `AdminConfigurations_accordionContent__hL5jP`,
	"slideDown": `AdminConfigurations_slideDown__zlHPq`,
	"submitButton": `AdminConfigurations_submitButton__vd-+H`,
	"gridTwoColumns": `AdminConfigurations_gridTwoColumns__h4m29`,
	"themes": `AdminConfigurations_themes__O0rVR`,
	"theme": `AdminConfigurations_theme__wT2lj`,
	"theme__active": `AdminConfigurations_theme__active__ech8G`,
	"theme__set": `AdminConfigurations_theme__set__FnjtQ`
};
export default ___CSS_LOADER_EXPORT___;
